import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetAdminLeaderboardResponse } from './get-admin-leaderboard-response';
import { getAdminLeaderboardResponseSchema } from './get-admin-leaderboard-response';

interface IGetAdminLeaderboardParams {
  limit?: number;
  offset?: number;
  search?: string;
}

export async function getAdminLeaderboardApi(
  params?: IGetAdminLeaderboardParams,
): Promise<IValidatedResponse<IGetAdminLeaderboardResponse>> {
  return getRequest<IGetAdminLeaderboardResponse>({
    path: '/sys/leaderboard',
    schema: getAdminLeaderboardResponseSchema,
    options: {
      params: {
        limit: params?.limit ?? 50,
        offset: params?.offset ?? 0,
        search: params?.search,
      },
    },
  });
}
